
(function(){
  var root = document.querySelector('.hasd-wte');
  if(!root) return;
  root.addEventListener('click', function(e){
    var btn = e.target.closest('.row__btn, .panel__btn');
    if(!btn || !root.contains(btn)) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if(!body) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    body.hidden = open;
  });
  var rows = [].slice.call(root.querySelectorAll('.row'));
  var count = root.querySelector('#wte-count');
  function apply(filter){
    var shown = 0;
    rows.forEach(function(r){
      var ok = filter === 'all'
        || (filter === 'home' && r.dataset.place !== 'out')
        || (filter === 'out'  && r.dataset.place !== 'home')
        || (filter === 'fast' && parseInt(r.dataset.time,10) <= 2);
      r.hidden = !ok;
      if(ok) shown++;
    });
    root.querySelectorAll('.grp').forEach(function(g){
      g.hidden = !g.querySelector('.row:not([hidden])');
    });
    if(count) count.textContent = shown === rows.length
      ? 'Showing all ' + rows.length
      : 'Showing ' + shown + ' of ' + rows.length;
  }
  root.querySelectorAll('.tool[data-filter]').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('.tool[data-filter]').forEach(function(x){
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        x.style.borderColor = x === b ? '#1A1916' : '';
        x.style.color = x === b ? '#1A1916' : '';
      });
      apply(b.dataset.filter);
    });
  });
  var expand = root.querySelector('#wte-expand');
  if(expand) expand.addEventListener('click', function(){
    var anyClosed = !!root.querySelector('.row:not([hidden]) .row__btn[aria-expanded="false"]');
    root.querySelectorAll('.row:not([hidden]) .row__btn').forEach(function(b){
      b.setAttribute('aria-expanded', anyClosed ? 'true' : 'false');
      document.getElementById(b.getAttribute('aria-controls')).hidden = !anyClosed;
    });
    expand.textContent = anyClosed ? 'Close all' : 'Open all';
  });
})();